"use strict";

var _history = require("@reach/router/lib/history");

var currentPathName;
var offsetY = 0;

var scrollToHash = function scrollToHash() {
  // Make sure React has had a chance to flush to DOM first and apply styles.
  setTimeout(function () {
    var hash = window.decodeURI(window.location.hash.replace("#", ""));

    if (hash !== "") {
      var element = document.getElementById(hash);

      if (element) {
        var offset = element.offsetTop;
        window.scrollTo(0, offset - offsetY);
      }
    }
  }, 10);
};

_history.globalHistory.listen(function () {
  if (location.pathname === currentPathName) {
    scrollToHash();
  }
});

exports.onClientEntry = function (args, pluginOptions) {
  if (pluginOptions.offsetY) {
    offsetY = pluginOptions.offsetY;
  }
};

exports.onRouteUpdate = function (_ref, pluginOptions) {
  var location = _ref.location;
  scrollToHash();
  currentPathName = location.pathname;
};